<div class="section-header no-title">
  <div class="section-actions">
    <mat-form-field appearance="outline" class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        type="text"
        placeholder="Search by name, ID, project…"
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchChange()"
      />
      <button
        *ngIf="searchText"
        matSuffix
        mat-icon-button
        aria-label="Clear search"
        (click)="clearSearch()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="inline-filter">
      <mat-label>Projects</mat-label>
      <mat-select
        [(value)]="selectedProjectIds"
        (selectionChange)="onProjectsFilterChange()"
        (openedChange)="onProjectsPanelOpenedChange($event)"
        multiple
        placeholder="All"
        panelClass="finance-filter-search-panel"
      >
        <mat-select-trigger>
          {{ selectedProjectIds.length ? selectedProjectIds.length + ' selected' : 'All' }}
        </mat-select-trigger>

        <div class="select-search" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <mat-icon class="select-search-icon">search</mat-icon>
          <input
            type="text"
            class="select-search-input"
            placeholder="Search projects"
            [(ngModel)]="projectFilterText"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          />
          <button
            *ngIf="projectFilterText"
            type="button"
            mat-icon-button
            class="select-search-clear"
            aria-label="Clear search"
            (click)="projectFilterText = ''; $event.stopPropagation()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <mat-option *ngFor="let p of filteredProjectOptions" [value]="p.id">
          {{ p.projectName }}<ng-container *ngIf="p.projectIdCode"> | {{ p.projectIdCode }}</ng-container>
        </mat-option>
        <mat-option *ngIf="filteredProjectOptions.length === 0" disabled>
          {{ projectOptions.length === 0 ? 'No projects available' : 'No projects match "' + projectFilterText + '"' }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="inline-filter">
      <mat-label>LOB</mat-label>
      <mat-select
        [(value)]="selectedSupportingLobs"
        (selectionChange)="onSupportingLobsFilterChange()"
        multiple
        placeholder="All"
      >
        <mat-select-trigger>
          {{ selectedSupportingLobs.length ? selectedSupportingLobs.length + ' selected' : 'All' }}
        </mat-select-trigger>
        <mat-option *ngFor="let lob of supportingLobOptions" [value]="lob.code">{{ lob.label }}</mat-option>
        <mat-option *ngIf="supportingLobOptions.length === 0" disabled>No options available</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<ng-container *ngIf="loading">
  <ngx-skeleton-loader count="8" [theme]="{ height: '44px', 'margin-bottom': '4px' }"></ngx-skeleton-loader>
</ng-container>

<div *ngIf="errorMessage && !loading" class="error-state">{{ errorMessage }}</div>

<ng-container *ngIf="!loading && !errorMessage">
  <div class="table-wrap">
    <table mat-table [dataSource]="rows" [trackBy]="trackByRateCardId" class="rate-card-table">
      <!-- Resource (sticky, blanked on continuation rows) -->
      <ng-container matColumnDef="resource" sticky>
        <th mat-header-cell *matHeaderCellDef>Resource</th>
        <td mat-cell *matCellDef="let row">
          <div class="name-cell" *ngIf="!row.isContinuation">
            <a class="resource-link" (click)="navigateToEdit(row)">{{ row.resourceName }}</a>
            <span class="emp-id">
              {{ row.employeeId }}<ng-container *ngIf="row.role"> | {{ row.role }}</ng-container>
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="history" sticky>
        <th mat-header-cell *matHeaderCellDef>History</th>
        <td mat-cell *matCellDef="let row">
          <button
            *ngIf="!row.isContinuation"
            type="button"
            mat-icon-button
            class="row-action"
            aria-label="View history"
            matTooltip="View history"
            (click)="navigateToHistory(row)"
          >
            <mat-icon>history</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="edit" sticky>
        <th mat-header-cell *matHeaderCellDef>Edit</th>
        <td mat-cell *matCellDef="let row">
          <button
            type="button"
            mat-icon-button
            class="row-action"
            aria-label="Edit"
            matTooltip="Edit"
            (click)="navigateToEdit(row)"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="dntIndiaLeader">
        <th mat-header-cell *matHeaderCellDef>D&T India Leader</th>
        <td mat-cell *matCellDef="let row">{{ row.dntIndiaLeader || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef>Start Date</th>
        <td mat-cell *matCellDef="let row">
          {{ row.startDate ? (row.startDate | date: 'dd/MM/yy') : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="endDate">
        <th mat-header-cell *matHeaderCellDef>End Date</th>
        <td mat-cell *matCellDef="let row">
          {{ row.endDate ? (row.endDate | date: 'dd/MM/yy') : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tierModel">
        <th mat-header-cell *matHeaderCellDef>Tier</th>
        <td mat-cell *matCellDef="let row">{{ row.tierModel || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="baseRate">
        <th mat-header-cell *matHeaderCellDef class="num-col">Base Rate</th>
        <td mat-cell *matCellDef="let row" class="num-col">
          {{ row.baseRate != null ? ('$' + row.baseRate) : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="officeExpRecovery">
        <th mat-header-cell *matHeaderCellDef class="num-col">Office Exp</th>
        <td mat-cell *matCellDef="let row" class="num-col">
          {{ row.officeExpRecovery != null ? ('$' + row.officeExpRecovery) : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dntCost">
        <th mat-header-cell *matHeaderCellDef class="num-col">D&T Cost</th>
        <td mat-cell *matCellDef="let row" class="num-col">
          {{ row.dntCost != null ? ('$' + row.dntCost) : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="projectCost">
        <th mat-header-cell *matHeaderCellDef class="num-col">Project Cost</th>
        <td mat-cell *matCellDef="let row" class="num-col">
          {{ row.projectCost != null ? ('$' + row.projectCost) : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="poType">
        <th mat-header-cell *matHeaderCellDef>PO Type</th>
        <td mat-cell *matCellDef="let row">{{ row.poType || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="employer">
        <th mat-header-cell *matHeaderCellDef>Employer</th>
        <td mat-cell *matCellDef="let row">{{ row.employer || '—' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="empty-row" *matNoDataRow>
        <td [attr.colspan]="displayedColumns.length">
          No rate card data matches the current filters.
        </td>
      </tr>
    </table>
  </div>

  <mat-paginator
    class="rate-card-paginator"
    [length]="totalElements"
    [pageSize]="size"
    [pageIndex]="page"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="onPageEvent($event)"
    aria-label="Rate Card pagination"
  ></mat-paginator>
</ng-container>
